import { DecimalPipe } from '@angular/common';
import { CurrencyUtil } from '@liquitics/transaction';
import { CurrencyDisplayUtil } from './../common/currency-display-util';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'currencyrounding'
})
export class CurrencyRoundingPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) {

    }

    transform(value: number, decimals: number, currency: string, includeSuffix?: boolean): string {
        const scale = CurrencyUtil.currencyScalePower(currency);
        const suffix = (includeSuffix) ? CurrencyDisplayUtil.currencyScaleSuffix(currency) : '';
        return this.decimalPipe.transform(CurrencyUtil.roundAndScale(value, decimals, scale), '1.' + decimals + '-' + decimals) + suffix;
    }
}
